/**
 * 统一获取当前登录的批发商 ID
 * 
 * 数据来源：登录选择商户后保存在 localStorage.stored_wholesaler_id
 * 
 * 用法：
 *   import { getWholesalerId } from '@/utils/wholesaler'
 *   const id = getWholesalerId()
 * 
 * 注意：如果用户未选择批发商或未登录，返回 null
 * 如果业务逻辑需要默认值，调用时处理：getWholesalerId() ?? 1
 */
export function getWholesalerId() {
  const stored = localStorage.getItem('stored_wholesaler_id')
  if (stored) {
    // 去除所有可能的引号（英文单引号、中文单引号、双引号等）
    const cleaned = stored.replace(/['"''""]/g, '').trim()
    const id = Number(cleaned)
    if (id > 0) return id
    console.warn('⚠️ stored_wholesaler_id 无法转换为数字:', stored, '-> cleaned:', cleaned)
  }
  return null
}
